<template>
  <div>
    <h6>Satisfaction</h6>

    <!-- แสดงผลเมื่อได้รับการประเมินแล้ว -->
    <div v-if="hasVoted">
      <div
        class="text-center my-15"
        style="display: flex; justify-content: center; align-items: center; margin: 16px 0;"
      >
        <a-rate style="font-size: 32px" :value="Number(dataSuccess.ticketpoint)" disabled />
      </div>
      <div
        class="mt-10"
        style="border-radius: 6px; background-color: #f5f7fa; border: 1px solid #e4e7ed; padding: 12px 16px;"
      >
        <p class="mb-5 text-muted" style="font-size: 0.85rem; font-weight: 600;">
          Suggestion :
        </p>
        <p class="mb-0 text-dark" style="white-space: pre-wrap;">
          {{ dataSuccess.ticketcomment || '-' }}
        </p>
      </div>
    </div>

    <!-- ฟอร์มสำหรับให้คะแนนและส่งผลโหวตเมื่อยังไม่เคยประเมิน -->
    <div v-else>
      <div
        class="text-center my-15"
        style="display: flex; justify-content: center; align-items: center; margin: 16px 0;"
      >
        <a-rate style="font-size: 32px" v-model="formResolved.ticketpoint" />
      </div>
      <a-form-item class="mt-10 mb-10">
        <a-textarea
          v-model="formResolved.ticketcomment"
          placeholder="Add more suggestion (if any) ..."
          :rows="4"
        />
      </a-form-item>

      <a-space>
        <div v-if="!loading.formA">
          <a-button @click="submitEvaluation" class="mr-10" type="primary">
            Submit
          </a-button>
          <a-button @click="clearCondition" type="danger"> Cancel </a-button>
        </div>
        <p v-else class="mt-10 mb-10"><a-spin class="mr-5" />Loading...</p>
      </a-space>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSuccess: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formResolved: {
        ticketcomment: (this.dataSuccess && this.dataSuccess.ticketcomment) || "",
        ticketpoint: (this.dataSuccess && this.dataSuccess.ticketpoint) || 0,
      },
      loading: {
        formA: false,
      },
    };
  },
  computed: {
    hasVoted() {
      if (!this.dataSuccess) return false;
      const point = this.dataSuccess.ticketpoint;
      return (
        point !== null &&
        point !== undefined &&
        point !== "" &&
        point !== "null" &&
        Number(point) > 0
      );
    },
  },
  watch: {
    dataSuccess: {
      handler(val) {
        if (val) {
          this.formResolved.ticketcomment = val.ticketcomment || "";
          this.formResolved.ticketpoint = val.ticketpoint || 0;
        }
      },
      deep: true,
    },
  },
  methods: {
    clearCondition() {
      this.formResolved = {
        ticketcomment: (this.dataSuccess && this.dataSuccess.ticketcomment) || "",
        ticketpoint: (this.dataSuccess && this.dataSuccess.ticketpoint) || 0,
      };
      this.loading.formA = false;
    },
    async addEvaluation() {
      const sendVote = new FormData();
      sendVote.append("ticketcomment", this.formResolved.ticketcomment || "");
      sendVote.append("ticketpoint", this.formResolved.ticketpoint || 0);
      try {
        const id = this.dataSuccess ? this.dataSuccess.id : "";
        const resVote = await this.$http.patch(
          `/ticket/vote/${id}/`,
          sendVote,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (resVote && resVote.status === 200) {
          if (this.$message && this.$message.success) {
            this.$message.success("Success tips for vote");
          }
          this.$emit("changeStatusTicket", resVote.data, { closeDetail: true });
          this.$emit("closeDetail", resVote.data);
          this.loading.formA = false;
        } else {
          const error = new Error("Request Failed");
          error.resVote = resVote;
          error.response = resVote;
          throw error;
        }
      } catch (error) {
        this.loading.formA = false;
        const id = this.dataSuccess ? this.dataSuccess.id : "";
        if (this.$notification && this.$notification.open) {
          this.$notification.open({
            style: {
              backgroundColor: "#ff1919",
              color: "#ffffff",
            },
            message: function (h) {
              return h("div", [
                h(
                  "strong",
                  { class: "" },
                  `Error ${error && error.response ? error.response.status : ""}`
                ),
              ]);
            },
            description: `Problem issue connect api : /ticket/vote/${id}/`,
          });
        }
      }
    },
    async submitEvaluation() {
      this.loading.formA = true;
      await this.addEvaluation();
    },
  },
};
</script>
